// esignReminderScheduleService.js
//
// Thin async wrappers over FetchAPI for the e-sign reminder schedule endpoints
// (ESignReminderScheduleController). Colocated with the panel because this
// state is single-screen; mirrors the style of apiKeysService.js.
//
// FetchAPI auto-attaches `Authorization: Bearer <authUser.token>` from
// localStorage, sends a JSON body for non-GET (so DELETE carries its array),
// and returns `undefined` on a 401 — callers must null-check.
//
// NOTE: never put a lowercase `id` on a create item — FetchAPI would append
// `/<id>` to the POST url and break the /esignreminderschedule/create route.
// Capital `Id` on update payloads is safe.

import { FetchAPI } from "../../../../helpers/APIdata/fetchAPI";

// GET /esignreminderschedule/list -> { status, message, esignreminderschedule_list: [...] }
export const listReminderSchedules = () =>
  FetchAPI("/esignreminderschedule/list", "GET");

// GET /esignreminderschedule/data/{id}
//   -> { esignreminderschedule_data: { ..., esignreminderschedulestep_list:[...] } }
export const getReminderScheduleData = (id) =>
  FetchAPI("/esignreminderschedule/data/" + id, "GET");

// POST /esignreminderschedule/create
// scheduleArray: [{ Name, Description, FlagDefault, MaxReminders,
//                   esignreminderschedulestep_list:[{StepOrder,OffsetDays,...}] }]
export const createReminderSchedule = (scheduleArray) =>
  FetchAPI("/esignreminderschedule/create", "POST", scheduleArray);

// PUT /esignreminderschedule/update — capital Id is safe.
export const updateReminderSchedule = (scheduleArray) =>
  FetchAPI("/esignreminderschedule/update", "PUT", scheduleArray);

// DELETE /esignreminderschedule/delete — body is an array of ids.
export const deleteReminderSchedules = (idArray) =>
  FetchAPI("/esignreminderschedule/delete", "DELETE", idArray);
